import { lookAtBack, lookAtFront } from "@rendering/vortex-core";
import React, { useEffect, useState } from "react";
import { useVortexContext } from "./vortexContext";
export function VortexActions(_ref) {
  let {
    cameraViews,
    animations,
    children
  } = _ref;
  var _a;
  const {
    preview
  } = useVortexContext();
  const [actionRunning, setActionRunning] = useState();
  const product = preview === null || preview === void 0 ? void 0 : preview.product;
  const [currentState, setCurrentState] = useState(product === null || product === void 0 ? void 0 : product.getCurrentState());
  useEffect(() => {
    setCurrentState(product === null || product === void 0 ? void 0 : product.getCurrentState());
    const onStateChange = e => {
      setCurrentState(e.state);
    };
    preview === null || preview === void 0 ? void 0 : preview.addEventListener("stateChange", onStateChange);
    return () => {
      preview === null || preview === void 0 ? void 0 : preview.removeEventListener("stateChange", onStateChange);
    };
  }, [preview, product]);
  const states = (_a = product === null || product === void 0 ? void 0 : product.getStates()) !== null && _a !== void 0 ? _a : [];
  const defaultAnimationDuration = 2;
  const stateActions = states.map(state => {
    var _a, _b, _c, _d, _e;
    // If there is no current state it's impossible to show any buttons
    if (!currentState) return undefined;
    // Don't show a button for the state the product is already in
    if (state.id === currentState.id) return undefined;
    let name;
    // Animation to go to the previous state
    if (currentState.dependency && state.id === currentState.dependency.stateId) {
      name = (_b = (_a = currentState.dependency.animationNames) === null || _a === void 0 ? void 0 : _a.forward) !== null && _b !== void 0 ? _b : currentState.dependency.stateId;
    }
    // Animation to go to the next state
    if (state.dependency && currentState.id === state.dependency.stateId) {
      name = (_e = (_d = (_c = state.dependency) === null || _c === void 0 ? void 0 : _c.animationNames) === null || _d === void 0 ? void 0 : _d.backward) !== null && _e !== void 0 ? _e : state.id;
    }
    if (name) {
      return {
        id: state.id,
        name,
        onAnimate(args) {
          if (!preview) {
            return;
          }
          setActionRunning(state.id);
          preview.transitionState(state.id, {
            duration: args === null || args === void 0 ? void 0 : args.animationDuration,
            scaleToFitGeometry: args === null || args === void 0 ? void 0 : args.scaleToFitGeometry,
            centerGeometry: args === null || args === void 0 ? void 0 : args.centerGeometry
          }).then(() => {
            setActionRunning(undefined);
          }).catch(() => {
            setActionRunning(undefined);
          });
        }
      };
    }
    return undefined;
  }).filter(Boolean);
  const changeOrientation = (type, args) => {
    var _a, _b;
    if (!preview) {
      return;
    }
    setActionRunning(type);
    if (type === "front") {
      lookAtFront(preview, (_a = args === null || args === void 0 ? void 0 : args.animationDuration) !== null && _a !== void 0 ? _a : defaultAnimationDuration).then(() => setActionRunning(undefined));
    } else {
      lookAtBack(preview, (_b = args === null || args === void 0 ? void 0 : args.animationDuration) !== null && _b !== void 0 ? _b : defaultAnimationDuration).then(() => setActionRunning(undefined));
    }
  };
  const focusFront = {
    id: "front",
    name: "Front",
    onAnimate(args) {
      changeOrientation("front", args);
    }
  };
  const focusBack = {
    id: "back",
    name: "Back",
    onAnimate(args) {
      changeOrientation("back", args);
    }
  };
  const actions = [];
  if (preview) {
    if (cameraViews) {
      actions.push(focusFront);
    }
    if (animations) {
      actions.push(...stateActions);
    }
    if (cameraViews) {
      actions.push(focusBack);
    }
  }
  return React.createElement(React.Fragment, null, children({
    actions,
    actionRunning
  }));
}